import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import { selectSettingKillSwitchMode } from 'src/app/stores/settings';

import { CustomSnackbarService } from '../../components/custom-snackbar/custom-snackbar.service';
import { KILL_SWITCH_MODE, TOAST_TYPES } from '../../utils/constants';

@Injectable({ providedIn: 'root' })
export class KillSwitchService {
  constructor(private store: Store, private snackbar: CustomSnackbarService) {}

  handleKillSwitchMode(): void {
    this.store
      .select(selectSettingKillSwitchMode)
      .pipe(take(1))
      .subscribe((killSwitchMode) => {
        if (killSwitchMode === KILL_SWITCH_MODE.WARNING) {
          this.snackbar.openSnackBar('common.killSwitchWarnMsg', TOAST_TYPES.Warning);
        }
      });
  }
}
